import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-input-column-filter',
  templateUrl: './input-column-filter.component.html',
  styleUrls: ['./input-column-filter.component.scss']
})
export class InputColumnFilterComponent implements OnInit {

  filterText = '';
  columnToFilter: string;

  filter = '';

  disabled = true;
  params: any;
  valueGetter: any;

  constructor() {
  }

  ngOnInit() {
  }

  agInit(params: any): void {
    this.params = params;
    this.columnToFilter = params.colDef.field;
  }

  isFilterActive() {
    return this.disabled !== false;
  }

  doesFilterPass(params): boolean {
    const value = this.params.valueGetter(params.node);
    return value.toLowerCase().includes(this.filterText.toLowerCase());
  }

  getModel() {
    return {filter: this.filter};
  }

  setModel(model) {
    this.filter = model ? model.filter : '';
  }
}
